import {
  DATA_CONNECTOR_AIRTABLE_WORKSPACE_LIST_BEGIN,
  DATA_CONNECTOR_AIRTABLE_WORKSPACE_LIST_SUCCESS,
  DATA_CONNECTOR_AIRTABLE_WORKSPACE_LIST_FAILURE,
  DATA_CONNECTOR_AIRTABLE_WORKSPACE_LIST_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';
export function airtableWorkspaceList(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_AIRTABLE_WORKSPACE_LIST_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/airtable/get-workspace`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_AIRTABLE_WORKSPACE_LIST_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_AIRTABLE_WORKSPACE_LIST_FAILURE,
            data: { error: err },
          });
          toast.error(`Failed: Please Check your Credentials !`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissAirtableWorkspaceListError() {
  return {
    type: DATA_CONNECTOR_AIRTABLE_WORKSPACE_LIST_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_AIRTABLE_WORKSPACE_LIST_BEGIN:
      return {
        ...state,
        airtableWorkspaceListPending: true,
        airtableWorkspaceListError: null,
      };

    case DATA_CONNECTOR_AIRTABLE_WORKSPACE_LIST_SUCCESS:
      // console.log('actionssss', action.data);
      return {
        ...state,
        airtableWorkspaceListPending: false,
        airtableWorkspaceListError: null,
        airtableWorkspaces: action.data,
      };

    case DATA_CONNECTOR_AIRTABLE_WORKSPACE_LIST_FAILURE:
      return {
        ...state,
        airtableWorkspaceListPending: false,
        airtableWorkspaceListError: action.data.error,
      };

    case DATA_CONNECTOR_AIRTABLE_WORKSPACE_LIST_DISMISS_ERROR:
      return {
        ...state,
        airtableWorkspaceListError: null,
      };

    default:
      return state;
  }
}
